import React from 'react';
import GirlCard from './GirlCard';
import { Girl } from '../../types';
import { useIsDesktop } from '../../hooks/useIsDesktop';

interface GirlsGridProps {
  girls: Girl[];
  onCardClick: (girl: Girl) => void;
}

const GirlsGrid: React.FC<GirlsGridProps> = ({ girls, onCardClick }) => {
  const isDesktop = useIsDesktop();

  return (
    <>
      <div className="px-4 lg:px-8 lg:max-w-[1200px] lg:mx-auto">
        <h2 className="font-anton text-xl uppercase mb-4 text-center lg:text-3xl lg:girls-grid-heading">
          {isDesktop ? (
            <span
              className="text-transparent bg-clip-text"
              style={{
                background:
                  'linear-gradient(100.85deg, #8350CB 4.87%, #FE6283 121.66%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
              }}
            >
              {' '}
              EXPLORE AI GIRLS{' '}
            </span>
          ) : (
            <>
              <span
                className="text-transparent bg-clip-text"
                style={{
                  background:
                    'linear-gradient(100.85deg, #8350CB 4.87%, #FE6283 121.66%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                {' '}
                EXPLORE{' '}
              </span>
              <span className="text-white">AI GIRLS</span>
            </>
          )}
        </h2>

        {/* Grid of AI Girls - 2 columns mobile, 4 columns desktop */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 pb-6 lg:pb-12">
          {girls.map((girl) => (
            <GirlCard
              key={girl.id}
              girl={girl}
              onClick={() => onCardClick(girl)}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default GirlsGrid;
